import { z } from 'zod';

export const filterSchema = z.object({
    startDate: z.string(),
    endDate: z.string(),
    view: z.discriminatedUnion('type', [
        z.object({
            type: z.literal('rateGroup'),
            value: z.string(),
        }),
        z.object({
            type: z.literal('rate'),
            value: z.string(),
        }),
    ]),
    resourceCategories: z.array(z.string()),
});

export type FilterFormValues = z.infer<typeof filterSchema>;
